import { vuexHandbook } from '@/store/composition/handbook'
import { SurfaceTreatmentApi } from '@/api/handbook/position/SurfaceTreatment/SurfaceTreatmentApi'

const state = () => ({
  ...vuexHandbook.createState(),
  api: SurfaceTreatmentApi
})

const getters = {
  ...vuexHandbook.createGetters()
}

const mutations = {
  ...vuexHandbook.createMutations()
}

const actions = {
  ...vuexHandbook.createActions()
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
